import theme from 'theme';
import styled, { keyframes } from 'styled-components';

const fadeInFocus = keyframes`
  from {
    opacity: 0;
    filter: blur(5px);
  }
  to {
    opacity: 1;
    filter: unset;
  }
`;

export const Styles = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};

  animation: ${fadeInFocus} 0.8s;

  h3 {
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
  }

  p {
    text-align: center;
    margin-bottom: 25px;
  }

  a {
    font-family: "Source Sans Pro", sans-serif;
    text-underline-position: under;
    font-weight: 600;
    margin-bottom: 60px;
  }

  @media ${theme.mediaQuery.tablet} {
    h3 {
      font-size: 1.2rem;
      color: ${({ theme }) => theme.colors.brandGold};
    }

    p {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.black};
    }

    a {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.brandGold};
    }
  }

  @media ${theme.mediaQuery.desktop} {
      h3 {
        font-size: 2.5rem;
        color: ${theme.colors.brandGold};
        padding: 20px;
      }

      p {
        font-size: 1.1rem;
        color: ${theme.colors.black};
        padding: 20px;
      }

      a {
        font-size: 1.1rem;
        color: ${theme.colors.brandGold};
      }
    }
  }
`;
